


















// @ is an alias to /src
import Vue from 'vue';
import MotionSearchView from '@/components/MotionSearchView.vue';
import ApiRequest from '@/util/apiRequest';

import { API_CATEGORY_QUERY, TITLE_TERMINATOR } from '../../util/config';

export default Vue.extend({
  name: 'home',
  data() {
    return {
      categoryName: '',
      categoryDescription: '',
      includeExplicit: false,
      queryReady: false,
    };
  },
  components: {
    MotionSearchView,
  },
  methods: {
    async load(forRoute) {
      try {
        const response = await ApiRequest.Get(API_CATEGORY_QUERY + forRoute.params.id);
        this.$data.categoryName = response.name;
        document.title = response.name + TITLE_TERMINATOR;
        this.$data.categoryDescription = response.description;
        this.$data.queryReady = true;
      } catch (error) {
        if (error.statusCode === 404) {
          this.$data.categoryName = 'Not Found';
        } else {
          throw error;
        }
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.load(to);
    next();
  },
  computed: {
    query() {
      return {
        categories: [parseInt(this.$route.params.id, 10)],
        explicitMode: this.$data.includeExplicit ? 1 : 0,
      };
    },
  },
  mounted() {
    this.load(this.$route);
  },
});
